// extracted by mini-css-extract-plugin
export default {"dropdownButton":"_3iIzZ","storeIcon":"_1Z1Ld"};